import type { ConsentCategory } from "./types";

/** The banner/gate copy, FR/EN (ADR-0013). Host apps may override via props for other locales. */
export interface ConsentLabels {
  bannerTitle: string;
  bannerBody: string;
  acceptAll: string;
  rejectAll: string;
  customise: string;
  save: string;
  categories: Record<ConsentCategory, { name: string; description: string }>;
  /** `ConsentGate` placeholder copy. `{name}` is replaced with the embed name. */
  gatePrompt: string;
  gateLoad: string;
}

export const FR_LABELS: ConsentLabels = {
  bannerTitle: "Vos préférences de confidentialité",
  bannerBody:
    "Nous utilisons des cookies strictement nécessaires au fonctionnement de la réservation. Avec votre accord, nous activons aussi des cookies fonctionnels, de mesure d'audience et de contenus tiers.",
  acceptAll: "Tout accepter",
  rejectAll: "Tout refuser",
  customise: "Personnaliser",
  save: "Enregistrer mes choix",
  categories: {
    strictlyNecessary: {
      name: "Strictement nécessaires",
      description: "Indispensables au fonctionnement de la réservation. Toujours actifs.",
    },
    functional: {
      name: "Fonctionnels",
      description: "Mémorisent vos préférences pour améliorer votre expérience.",
    },
    analytics: {
      name: "Mesure d'audience",
      description: "Nous aident à comprendre l'usage du site, de façon agrégée.",
    },
    thirdPartyEmbeds: {
      name: "Contenus tiers",
      description:
        "Affichent des contenus externes (carte, vidéos) qui déposent leurs propres cookies.",
    },
  },
  gatePrompt: "{name} nécessite votre accord pour les contenus tiers avant de se charger.",
  gateLoad: "Charger {name}",
};

export const EN_LABELS: ConsentLabels = {
  bannerTitle: "Your privacy preferences",
  bannerBody:
    "We use strictly necessary cookies to run the booking. With your consent we also enable functional, analytics and third-party-content cookies.",
  acceptAll: "Accept all",
  rejectAll: "Reject all",
  customise: "Customise",
  save: "Save my choices",
  categories: {
    strictlyNecessary: {
      name: "Strictly necessary",
      description: "Required for the booking to work. Always on.",
    },
    functional: {
      name: "Functional",
      description: "Remember your preferences to improve your experience.",
    },
    analytics: {
      name: "Analytics",
      description: "Help us understand site usage, in aggregate.",
    },
    thirdPartyEmbeds: {
      name: "Third-party content",
      description: "Show external content (map, videos) that set their own cookies.",
    },
  },
  gatePrompt: "{name} needs your consent for third-party content before it loads.",
  gateLoad: "Load {name}",
};
